import { ParcelListElementStatus } from '../enums/parcel-list-element-status.enum';
import { type ParcelItem } from '../models/parcel-item.model';

export function getParcelStatus(selectedParcels: ParcelItem[], parcel: ParcelItem) {
  return selectedParcels.map((parcel) => parcel.id).includes(parcel.id)
    ? ParcelListElementStatus.ADDED
    : ParcelListElementStatus.SELECTABLE;
}

export function getSelectedArea(selectedParcels: ParcelItem[]) {
  return Math.round(selectedParcels.reduce((sum, parcel) => sum + parcel.area, 0) * 100) / 100;
}
